import { format } from "date-fns";
import { getCurrencySymbol, getExChangeAmount, getTransectionDetails, toFixedTrunc } from "../client/Juno/helpers"
import ExcelJS from 'exceljs';
import { constant } from "../client/Juno/client/constant";

export const trim = (value) => {
    if (value && typeof value === 'string') {
        return value.trim()
    }
    return value
}


export const isBlank = (value) => {
    return !value || (typeof value == 'string' && trim(value) == '')
}

export const toNumber = (value) => {
    let result = Number(value)
    if (isNaN(result)) return 0 
    return result
}

export function generateUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
const downloadExcel = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};
export const generateExcel = async (data) => {
    const { fromDate, endDate, currency, transactionDetails, openingBalance, closingBalance,activeCurrencyPage } = data;

    const startingDate = format(fromDate, 'dd MMM');
    const endingDate = format(endDate, 'dd MMM');
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('February 2022');

    const addFormattedRow = (rowData, mergeCellsRange = null, isBold = false, alignment = {}) => {
        const row = worksheet.addRow(rowData);
        row.eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { wrapText: true, ...alignment };
            if (isBold) cell.font = { bold: true };
        });
        if (mergeCellsRange && !worksheet.getCell(mergeCellsRange).isMerged) {
            worksheet.mergeCells(mergeCellsRange);
        }
        return row;
    };

    const setColumns = () => {
        worksheet.columns = [
            { key: 'Date', width: 15 },
            { key: 'Time', width: 15 },
            { key: 'Type', width: 20 },
            { key: 'Details', width: 25 },
            { key: 'Reference', width: 25 },
            { key: 'Amount', width: 25 },
            { key: 'Balance', width: 25 },
        ];
    };
    const decimalPlaces = activeCurrencyPage === 'crypto' ? 8 : 2;
    addFormattedRow([`${currency} Statement`], 'A1:G1', true, { vertical: 'top', horizontal: 'left' });
    addFormattedRow(['Date', 'Time', 'Type', 'Details', 'Reference', 'Amount', 'Balance'], null, true);
    if (transactionDetails.length === 0) {
        addFormattedRow([startingDate, '', '', 'Statement Opening Balance', '', '', `${getCurrencySymbol(currency)} ${toFixedTrunc(openingBalance, decimalPlaces)}`]);
        if (!worksheet.getCell('A3').isMerged) {
            worksheet.mergeCells('A3:G3');
        }
        const noDataCell = worksheet.getCell('A3');
        noDataCell.value = 'No transactions available for this date range';
        noDataCell.alignment = { horizontal: 'center', vertical: 'middle' };
        noDataCell.font = { bold: true };

        addFormattedRow([endingDate, '', '', 'Statement Closing Balance', '', '', `${getCurrencySymbol(currency)} ${toFixedTrunc(closingBalance, decimalPlaces)}`]);
    } else {
        addFormattedRow([startingDate, '', '', 'Statement Opening Balance', '', '', `${getCurrencySymbol(currency)} ${toFixedTrunc(openingBalance, decimalPlaces)}`]);
        transactionDetails
            .filter(row => row)
            .forEach(row => {
                const feeText =
                    row?.type === constant.TRANSACTION_TYPE_CONSTANT.FIAT.FX || row?.currencyType === "crypto"
                        ? ''
                        : `Fee : ${getCurrencySymbol(currency)} ${toFixedTrunc(row?.transactionRef?.transactionFee || row?.transactionRef?.transferInFee) || 0.0}`;
                const getTransactionType = (row, currencyType) => {
                    const { type, transactionRef } = row;
                    if (type === constant.TRANSACTION_TYPE_CONSTANT.FIAT.TRANSFER) {
                        return `Transfer (${transactionRef?.transferInOut || ""})`;
                    }
                    if (currencyType === "fiat") {
                        if (type === constant.TRANSACTION_TYPE_CONSTANT.CRYPTO.BUY) return "Transfer (Out)";
                        if (type === constant.TRANSACTION_TYPE_CONSTANT.CRYPTO.SELL) return "Transfer (In)";
                    }
                    return type || "N/A";
                };
                const newRow = worksheet.addRow([
                    format(row.creationDate, 'dd MMM'),
                    new Date(row.creationDate).toLocaleTimeString(),
                    `${getTransactionType(row, activeCurrencyPage)}${feeText ? `\n${feeText}` : ''}`,
                    getTransectionDetails(row, activeCurrencyPage),
                    row.transactionRef?.transactionDetails[0]?.reference || "N/A",
                    getExChangeAmount(row, activeCurrencyPage),
                    `${getCurrencySymbol(currency)} ${toFixedTrunc(row.balanceAmount, activeCurrencyPage === 'crypto' ? 6 : 2)}`
                ]);
                newRow.eachCell({ includeEmpty: true }, (cell) => {
                    cell.alignment = { wrapText: true };
                });
            });

        addFormattedRow([endingDate, '', '', 'Statement Closing Balance', '', '', `${getCurrencySymbol(currency)} ${toFixedTrunc(closingBalance, decimalPlaces)}`]);
    }
    setColumns();
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    downloadExcel(blob, 'Account_Statement.xlsx');
};
